import { DropdownSelect } from "../components/common/DropdownSelect";
import { SelectView } from "../components/common/SelectView";
import { DateInput } from "../components/inputs/DateInput";
import { TextInput } from "../components/inputs/TextInput";
import {
  COMPONENT,
  DATE,
  MULTIPLE,
  SELECT,
  SELECT_VIEW,
  TEXT,
} from "../constants/constants";
import { capitalizeText, returnObject, stringify } from "./helpers";

export function RenderForm({
  form,
  fields,
  onChange,
  updateFormValues,
  updateChanges, // track changes to the form
  error,
}: {
  form?: any;
  fields?: any;
  onChange?: any;
  updateFormValues?: any;
  updateChanges?: any;
  error?: any;
}) {
  return (
    <>
      {fields?.map((formField: any, i: number) => {
        const {
          label,
          type,
          value,
          required,
          field,
          options = [],
          component,
          visible = true,
          fullWidth,
          optionKeys = [],
          // form_keys = [],
          props,
        } = formField || {};

        if (!visible) return null;

        function getLabel() {
          return capitalizeText(stringify(label || field));
        }

        function getFieldName() {
          return field || label?.toLowerCase();
        }

        function getValue() {
          return form?.[getFieldName()] || value;
        }

        const fieldProps = {
          label: getLabel(),
          field: getFieldName(),
          error,
          value: getValue(),
          required,
          props,
        };

        // Full-width style for fields that should span entire grid row
        const fullWidthStyle = fullWidth
          ? { gridColumn: "1 / -1" }
          : undefined;

        switch (type) {
          case TEXT:
            return (
              <TextInput
                key={i}
                label={getLabel()}
                name={getFieldName()}
                numberValue={form?.[getFieldName()]}
                value={getValue()}
                onChange={onChange}
                updateChanges={updateChanges}
                required={required}
                error={error}
                {...props}
              />
            );
          case SELECT:
            return (
              <DropdownSelect
                key={i}
                label={getLabel()}
                field={getFieldName()}
                value={getValue()}
                onClear={() => updateFormValues({ [field]: null })}
                options={
                  options?.length > 0 &&
                  options?.map((val: any) => getOptions(val, optionKeys))
                }
                onChange={(val: any, obj: any) => {
                  // mutiple options
                  if (props?.mode === MULTIPLE)
                    return updateFormValues({ [field]: val });

                  const values = getFormValues(field, obj);

                  if (updateChanges) updateChanges(values);

                  // set selected value to form
                  return updateFormValues(values);
                }}
                required={required}
                error={error}
                {...props}
              />
            );
          //   case CHECK_BOX:
          //     return (
          //       <GenericCheckBox
          //         key={i}
          //         label={getLabel()}
          //         field={getFieldName()}
          //         updateFormValues={updateFormValues}
          //         value={getValue()}
          //         {...props}
          //       />
          //     );
          //   case SWITCH:
          //     return (
          //       <GenericSwitch
          //         key={i}
          //         label={getLabel()}
          //         field={getFieldName()}
          //         updateFormValues={updateFormValues}
          //         value={getValue()}
          //         {...props}
          //       />
          //     );
          //   case FILE:
          //     return (
          //       <FileUpload
          //         key={i}
          //         label={getLabel()}
          //         field={getFieldName()}
          //         updateFormValues={updateFormValues}
          //         error={error}
          //         value={getValue()}
          //         required={required}
          //         {...props}
          //       />
          //     );

          case DATE:
            return (
              <DateInput
                key={i}
                updateFormValues={updateFormValues}
                updateChanges={updateChanges}
                {...fieldProps}
                {...props}
              />
            );

          case SELECT_VIEW:
            return (
              <SelectView
                key={i}
                value={getValue()}
                onSelect={(val) =>
                  updateFormValues({ [getFieldName()]: val })
                }
                options={options}
                error={error?.[getFieldName()]}
              />
            );

          case COMPONENT:
            return (
              <div key={i} style={fullWidthStyle}>
                {component}
              </div>
            );

          default:
            return null;
        }
      })}
    </>
  );
}

export function getValidators(sections: any[]) {
  let validators: any = [];
  sections?.forEach((item) => {
    if (item.visible === false) return;
    if (item.fields) validators = [...validators, ...item.fields];
  });
  return validators;
}

export type TOptionKey = {
  fieldKey: string;
  valueKey: string;
};

function getOptions(data: any, optionKeys: any[]) {
  // default for picker
  let defaultObject = {
    label: data?.name,
    value: data?.id,
    ...returnObject(data?.searchLabel, { searchLabel: data?.searchLabel }),
  };

  // override default for picker
  optionKeys.forEach((key: any) => {
    if (key instanceof Object) {
      defaultObject = {
        ...defaultObject,
        [key.fieldKey]: data[key.valueKey],
      };
    } else if (typeof key === "string") {
      optionKeys.forEach((key: any) => {
        defaultObject = { ...defaultObject, [key]: data?.[key] };
      });
    }
  });

  return defaultObject;
}

function getFormValues(field: any, data: any) {
  delete data?.searchLabel;
  let defaultObject = {
    [field]: data?.value,
  };

  Object.keys(data || {}).forEach((key) => {
    if (!["label", "value"].includes(key)) {
      defaultObject = { ...defaultObject, [key]: data[key] };
    }
  });

  return defaultObject;
}

export const PropOptions = {
  number: { type: "number" },
  disabled: { disabled: true },
  readOnly: { readOnly: true },
};